/**
 * Endeavorum's canonical taxonomy. Founder-defined 29 Jun 2026.
 *
 *   World  ->  Place  ->  Space  ->  Practice
 *   Endeavorum  Pursuital Arcade  the Cove  PlayForward
 *
 * A Place is the BUILDING. A Space is the room inside it. A Practice is what
 * the human actually DOES in that room. PlayForward and Stageward are
 * PRACTICES — not buildings, not realms. This is why the domains are named for
 * them: the URL names the work, not the software.
 *
 * Single source of truth for names. Anything rendering a Place, Space or
 * Practice label reads from here, so a rename is one edit and never drifts.
 */

export const PLACES = [
  {
    key: "playforward",          // Portal key — matches playforward.app
    place: "Pursuital Arcade",   // the building
    space: "the Cove",           // the room
    practice: "PlayForward",     // the work
    sub: "Name what you are actually trying to do",
    to: "/playforward",
    lit: true,
  },
  {
    key: "stageward",            // Portal key — matches stageward.app
    place: "Clarity Hall",
    space: "the Green Room",
    practice: "Stageward",
    sub: "Work out how",
    to: "/stageward/walk",
    lit: true,
  },
  { key: "the-arena", place: "The Arena", sub: "Not open yet", lit: false },
  // 2 o'clock island. Renamed 14 Feb 2026: "Venturyum Studio" → "Ops".
  // The Studio Space (broadcast set inside the Alcove — LunchOur.show) is
  // now subordinated to Ops as a Space, not a Place. See ARENA.md.
  { key: "ops", place: "Ops", space: "Studio Space", sub: "Not open yet", lit: false },
  { key: "mastermind-chamber", place: "Mastermind Chamber", sub: "Not open yet", lit: false },
  { key: "the-commons", place: "The Commons", sub: "Not open yet", lit: false },
  { key: "the-vault", place: "The Vault", sub: "Not open yet", lit: false },
  { key: "the-bridge", place: "The Bridge", sub: "Not open yet", lit: false },
  // Founder's note on the map: "an artifact, not a door."
  { key: "the-horizon-map", place: "The Horizon Map", sub: "An artifact, not a door", lit: false, artifact: true },
];

export const byKey = (key) => PLACES.find((p) => p.key === key);

/** "the Cove · Pursuital Arcade" — where a Practice happens, as a whisper. */
export const whereFor = (key) => {
  const p = byKey(key);
  return p?.space ? `${p.space} · ${p.place}` : p?.place || "";
};
